export { Modal } from './Modal';

//# sourceMappingURL=index.js.map